/**
 * Created by Mark on 17/04/2017.
 */

import BaseStore from './base-store.js';
import React from 'react';
import Constants from  '../constants/lessonplans.js'
import Language  from  '../classes/language.js';

class LessonPlanStore extends BaseStore {

    constructor(){
        super();
        this.subscribe(() => this._registerToActions.bind(this));
        this.plans = [];
    }


    _registerToActions(action) {

        switch(action.actionType)
        {
            case Constants.ALL_LESSONS_UPDATE :
                this.plans = action.response;
                this.emitChange();
                break;
        }
    }

    getPlans(){
        return this.plans
    }
}

export default new LessonPlanStore();


// WEBPACK FOOTER //
// ./src/store/lessonplan-store.js